import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
// Cybrbase design system — app-wide tokens + antd coherence bridge (additive).
// tokens.scss only takes effect where a `--cb-*` var is read (ui/ primitives, shell),
// so importing it changes no existing screen. The bridge is dormant until the
// `cb-bridge` class is added to <body> (deferred to the shell phase).
import "./styles/tokens.scss";
import "./styles/fonts.scss";
import "./styles/antd-bridge.scss";
// Shared page-layout classes (.list-container/.list-header/.list-title/…) for legacy
// screens inside the shell — re-homed here from the now-unmounted AppSidebar stylesheet.
import "./styles/page-layout.scss";
import "./styles/ops-surface.scss";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
